import styled from 'styled-components';

export const InputBarBlock = styled.div`
    position: ${(props)=>(props.displayType)?props.displayType:'fixed'};
    left:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: calc(100vw*(69/375));
    height:auto;
    background-color: #ffefce;
    padding : calc(100vw*(15/375)) calc(100vw*(17/375)) calc(100vw*(14/375)) calc(100vw*(16/375));
`;

export const ProfileImageArea = styled.div`
    width: calc(100vw*(40/375));
    height: calc(100vw*(40/375));
    border-radius: 50%;
    overflow:hidden;
    border: solid calc(100vw*(1/375)) #c6c6c6;
`;

export const CurrentUserProfileImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const InputForm = styled.div`
    position: relative;
    width: calc(100vw*(295/375));
    min-height: calc(100vw*(40/375));
    height:auto;
    border-radius: calc(100vw*(22/375));
    border: solid calc(100vw*(1/375)) #888888;
    margin-left: calc(100vw*(7/375));
    padding: calc(100vw * (10 / 375)) calc(100vw * (21 / 375));
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const TextArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height:100%;
    flex: 1 1 auto;

`;

export const TextInput = styled.textarea`
    background: none;
    width: 100%;
    font-size: calc(100vw*(14/375));
    color: #1d1d1d;
    //line-height: calc(100vw*(20/375));
`;

export const SubmitButton = styled.button`
    //position: absolute;
    //right: calc(100vw * (15 / 375));
    font-size: calc(100vw*(14/375));
    font-weight: 700;
    color: #ff8900;
    background: none;
    flex: 0 1 auto;
    white-space: nowrap;
`;
export const DisabledSubmitButton = styled(SubmitButton)` 
    color: #BCBDBF; 
`;